/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Voll360 extends CacheEnabledApiClient {
  constructor() {
    super('voll', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'voll';
  }

  async getTabulations(domain, api_key) {
    try {
      let response = await axios.get(`${this.url}/tabulations?domain=${domain}&api_key=${api_key}`);

      return response.data.data ?? [];
    } catch (error) {
      return null;
    }
  }

  async getAgents(domain, api_key) {
    try {
      let response = await axios.get(`${this.url}/agents?domain=${domain}&api_key=${api_key}`);

      return response.data.data ?? [];
    } catch (error) {
      return null;
    }
  }

  async getCampaigns(domain, api_key) {
    try {
      let response = await axios.get(`${this.url}/campaigns?domain=${domain}&api_key=${api_key}`);

      return response.data.data ?? [];
    } catch (error) {
      return null;
    }
  }
}

export default new Voll360();
